import React from "react";

const ExploreApplicant = () => {
  return <h1>Explore Applicants its work</h1>;
};

export default ExploreApplicant;
